import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { FaMapMarkerAlt } from 'react-icons/fa';
import MapForVendorDistance from '../../../Pages/Customers/Map/MapForVendorDistance';
import rightarrow from '../../../Assets/navbar/right-arrow.svg'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import LocationSearchPanel from '../../CompanyAdmin/Location1/LocationSearchPanel';
import { ClipLoader } from 'react-spinners';
import img2 from '../../../Assets/add/img2.png'
import rightArrow from '../../../Assets/navbar/right-arrow.svg';
import DummyMapFromOLA from '../DummyMapFromOLA';
import { LocateFixed, MapPin } from 'lucide-react';
import { motion, useAnimation } from 'framer-motion';

const SelectOnMap = ({ onLocationChange }) => {
  const [showSlideUp, setShowSlideUp] = useState(false);
  const slideRef = useRef(null);
  const [pickupLocation, setPickupLocation] = useState(null)
  // const [locationTooClose, setLocationTooClose] = useState(false);
  const [dropLocation, setDropLocation] = useState(null)
  const [activeField, setActiveField] = useState(null)
  const [isLoadingPlaces, setIsLoadingPlaces] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState("01");
  const [longitude, setLongitude] = useState(null)
  const [latitude, setLatitude] = useState(null)
  console.log('latitude918273912', latitude, longitude)
  const [dropLatitude, setDropLatitude] = useState(null)
  const [dropLongitude, setDropLongitude] = useState(null)
  const [pickupSuggestions, setPickupSuggestions] = useState([])
  const [destinationSuggestions, setDestinationSuggestions] = useState([])
  const OLAAPIKey = process.env.REACT_APP_OLA_API_KEY;

  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  useEffect(() => {

    const slideState = localStorage.getItem("showSlideUp");

    const storedPickup = localStorage.getItem('pickupLoc');
    const storedDrop = localStorage.getItem('dropLoc');
    if (storedPickup) setPickupLocation(storedPickup);
    if (storedDrop) setDropLocation(storedDrop);
    setShowSlideUp(slideState === "true");
  }, []);
  const controls = useAnimation();

  useEffect(() => {
    if (showSlideUp && slideRef.current) {
      gsap.to(slideRef.current, {
        y: 0,
        duration: 0.5,
        ease: 'power2.out',
      });
    }
  }, [showSlideUp]);

  const getDistanceInMeters = (lat1, lon1, lat2, lon2) => {
    const toRad = (value) => (value * Math.PI) / 180;

    const R = 6371000; // Earth radius in meters
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  };



  // Recalculate whenever pickup or drop changes
  useEffect(() => {
    if (
      latitude &&
      longitude &&
      dropLatitude &&
      dropLongitude
    ) {
      const distance = getDistanceInMeters(latitude, longitude, dropLatitude, dropLongitude);
      console.log("Distance:", distance);
      // setLocationTooClose(distance < 50); // less than 50 meters
    } else {
      // setLocationTooClose(false);
    }
  }, [pickupLocation, dropLocation]);

  useEffect(() => {
    if (typeof onLocationChange === 'function') {
      onLocationChange({
        latitude,
        longitude,
        pickupLocation,
        dropLocation,
        dropLatitude,
        dropLongitude,
        currentStep
      });
    } else {
      console.warn('onLocationChange is not a function');
    }
  }, [pickupLocation, dropLocation, currentStep]);


  const clearPickup = () => {
    setPickupLocation('');
    localStorage.removeItem('pickupLoc');
  };

  const clearDrop = () => {
    setDropLocation('');
    localStorage.removeItem('dropLoc');
  };

  const handlePickupChange = async (e) => {
    localStorage.setItem("showSlideUp", true);
    const inputValue = e.target.value;
    setPickupLocation(inputValue);
    localStorage.setItem('pickupLoc', inputValue)
    const encodedAddress = encodeURIComponent(inputValue);
    console.log('encodedAddress', encodedAddress)


    try {
      if (encodedAddress !== "") {
        const response = await fetch(`https://api.olamaps.io/places/v1/geocode?address=${encodedAddress}&language=hi&api_key=${OLAAPIKey}`);
        const data = await response.json();
        console.log('data123456', data)
        setPickupSuggestions(data.geocodingResults);
        console.log("Latitude:", data?.geocodingResults[0]?.geometry?.location?.lat);
        console.log("Longitude:", data?.geocodingResults[0]?.geometry?.location?.lng);


        const newLat = data?.geocodingResults[0]?.geometry?.location?.lat;
        const newLon = data?.geocodingResults[0]?.geometry?.location?.lng;

        setLatitude(newLat);
        setLongitude(newLon);

        // ✅ Now immediately use newLat and newLon here
        // setIsLoadingPlaces(true);
        setIsLoading(true);


        localStorage.setItem('pickLatitude', data?.geocodingResults[0]?.geometry?.location?.lat)
        localStorage.setItem('pickLongitude', data?.geocodingResults[0]?.geometry?.location?.lng)
        console.log("Latitude:", data?.geocodingResults[0]?.geometry?.location?.lat);
        console.log("Longitude:", data?.geocodingResults[0]?.geometry?.location?.lng);

        // setIsLoadingPlaces(false);
        setIsLoading(false);
        setIsPickupValid(false);
      }

    } catch (error) {
      console.error('Error fetching pickup data', error);
      setIsLoadingPlaces(false);
      setIsLoading(false);
    }
  }

  const getCurrentLocationAddress = (activeField) => {

    const storedLocation = localStorage.getItem('gps_location');
    const stroedursie = localStorage.getItem('userId');

    console.log('storedLocation', storedLocation)
    console.log('stroedursie', stroedursie)

    console.log('stored', storedLocation)
    const parsedLocation = JSON.parse(storedLocation);

    console.log('Real GPS location:', parsedLocation);
    const { lat, lng } = parsedLocation;

    if (activeField == "pickup") {
      setPickupLocation(localStorage.getItem('currentLoc'))
      localStorage.setItem('pickupLoc', localStorage.getItem('currentLoc'))

      const newDropLat = lat;
      const newDropLon = lng;

      setLatitude(newDropLat);
      setLongitude(newDropLon);

      localStorage.setItem('pickLatitude', lat)
      localStorage.setItem('pickLongitude', lng)
      localStorage.setItem('showSlideUp', false)

      setShowSlideUp(false)
      setIsPickupValid(true); // ✅ mark valid
    }


    else {
      setDropLocation(localStorage.getItem('currentLoc'))
      localStorage.setItem('dropLoc', localStorage.getItem('currentLoc'))
      const newDropLat = lat;
      const newDropLon = lng;

      setDropLatitude(newDropLat);
      setDropLongitude(newDropLon);

      localStorage.setItem('dropLatitude', lat)
      localStorage.setItem('dropLongitude', lng)
      localStorage.setItem('showSlideUp', false)

      setShowSlideUp(false)

      setIsDropValid(true);
    }

  }

  const handleDestinationChange = async (e) => {
    const inputValue = e.target.value;
    setDropLocation(inputValue);
    localStorage.setItem('dropLoc', inputValue)
    // const address = "Ola Electric, 2, Hosur Rd, Koramangala Industrial Layout, Koramangala, Bengaluru, 560095, Karnataka";
    const encodedAddress = encodeURIComponent(inputValue);

    try {
      // const response = await axios.get(`https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&q=${encodeURIComponent(inputValue)}`);
      const response = await fetch(`https://api.olamaps.io/places/v1/geocode?address=${encodedAddress}&language=hi&api_key=${OLAAPIKey}`);
      const data = await response.json();
      console.log('data123456destination', data)
      setDestinationSuggestions(data.geocodingResults)

      console.log("Latitude:", data?.geocodingResults[0]?.geometry?.location?.lat);
      console.log("Longitude:", data?.geocodingResults[0]?.geometry?.location?.lng);


      const newDropLat = data?.geocodingResults[0]?.geometry?.location?.lat;
      const newDropLon = data?.geocodingResults[0]?.geometry?.location?.lng;

      setDropLatitude(newDropLat);
      setDropLongitude(newDropLon);


      if (newDropLat && newDropLon) {
        // setIsLoadingPlaces(true);

        localStorage.setItem('dropLatitude', data?.geocodingResults[0]?.geometry?.location?.lat)
        localStorage.setItem('dropLongitude', data?.geocodingResults[0]?.geometry?.location?.lng)
        // setIsLoadingPlaces(false);
        setIsDropValid(false);
      }
    } catch (error) {
      console.error('Error fetching destination data', error);
      setIsLoadingPlaces(false);
    }
  }

  useEffect(() => {

    let pickupLoc = localStorage.getItem('pickupLoc')
    let dropLoc = localStorage.getItem('dropLoc')

    let latitude = localStorage.getItem('latitude')
    let longitude = localStorage.getItem('longitude')

    let dropLatitude = localStorage.getItem('dropLatitude')
    let dropLongitude = localStorage.getItem('dropLongitude')

    setPickupLocation(pickupLoc)
    setDropLocation(dropLoc)


    setLatitude(latitude);
    setLongitude(longitude);

    setDropLatitude(dropLatitude);
    setDropLongitude(dropLongitude);

    let droploc = localStorage.getItem('dropLoc')

    // alert(dropLocation)

    if (dropLoc) {
      setIsDropValid(true)
    }

  }, [])


  useEffect(() => {
    // Disable scroll when slide-up is shown
    if (showSlideUp || !showSlideUp) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto'; // Clean up the scroll lock when component unmounts
    };
  }, [showSlideUp, !showSlideUp]);

  const [isPickupValid, setIsPickupValid] = useState(true);
  const [isDropValid, setIsDropValid] = useState(false);


  return (
    <div>

      <div className='flex gap-4 bg-white relative'>

        <div className="font-satoshi min-h-[100dvh] bg-black text-white flex flex-col w-full md:max-w-[calc(100%)] relative">

          <DummyMapFromOLA
            latitude={latitude}
            longitude={longitude}
            dropLongitude={dropLongitude}
            dropLatitude={dropLatitude}
            setLatitude={setLatitude}
            setLongitude={setLongitude}
            setDropLatitude={setDropLatitude}
            setDropLongitude={setDropLongitude}
            setDropLocation={setDropLocation}
            setPickupLocation={setPickupLocation}
            inSideSelectOnMap={true}


          />


          {/* Bottom Card */}
          <div className="absolute bottom-0 w-full p-4 bg-white bg-opacity-90 rounded-t-2xl z-[999] mb-[4rem]">
            <h2 className="text-lg text-black font-bold">Set Pickup & Destination</h2>
            <p className="text-sm text-gray-400">Drag map to move pin</p>
            <div style={{ border: '1px solid #21a6e9' }} className="mt-4 bg-white px-4 py-2 rounded-lg flex items-center">
              <input
                  style={{fontSize:'12px'}}

                className="border-none text-black outline-none w-full sm:text-[12px] md:text-[16px]"
                onClick={() => {
                  setActiveField('pickup');
                  setShowSlideUp(true);
                  gsap.to(slideRef.current, {
                    y: 0,
                    duration: 0.4
                  });
                }}
                value={pickupLocation}
                name="pickup"
                onChange={handlePickupChange}
                placeholder="Pickup Location"
              />



            </div>
            <div style={{ border: '1px solid #21a6e9' }} className="mt-2 bg-white px-4 py-2 rounded-lg flex items-center">

              <input
                  style={{fontSize:'12px'}}

                className="border-none text-black outline-none w-full sm:text-[12px] md:text-[16px]"
                onClick={() => {
                  setActiveField('destination');
                  setShowSlideUp(true);
                  gsap.to(slideRef.current, {
                    y: 0,
                    duration: 0.4
                  });
                }}
                value={dropLocation}
                name="destination"
                onChange={handleDestinationChange}
                placeholder="Where To?"
              />
            </div>

          </div>

          {/* Slide-up Page */}
          {showSlideUp && (
            <motion.div
              ref={slideRef}
              className="absolute left-0 bottom-0 w-full h-[95vh] bg-white text-black rounded-t-3xl pt[0.2rem] p-4 z-[999]"
              drag="y"
              dragConstraints={{ top: 0, bottom: 100 }}
              onDragEnd={(e, info) => {
                if (info.offset.y > 100) {
                  // Swipe down
                  controls.start({ y: '100%', transition: { duration: 0.3 } }).then(() =>
                    setShowSlideUp(false)
                  );
                } else {
                  // Restore to original position if not swiped far enough
                  controls.start({ y: 0, transition: { duration: 0.2 } });
                }
              }}
              animate={controls}
              initial={{ y: '100%' }}
              animate={{ y: 0 }}
              transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            >
              <div className='flex justify-between items-center'>
                {/* <h2 className="text-lg text-black font-bold">Set Pickup & Destination</h2> */}
                <div className="flex justify-between items-center mb-2">
                  <p className="text-[12px] mt-3 opacity-90">Vehicle Breakdown / Spot Location</p>
                </div>
                <button onClick={() => {
                  gsap.to(slideRef.current, {
                    y: '100%',
                    duration: 0.4,
                    onComplete: () => setShowSlideUp(false)
                  });
                }}>Close</button>
              </div>

              <div className="w-full">
                {/* <div className="flex justify-between items-center mb-2">
                  <p className="text-[12px] mt-3 opacity-90">Vehicle Breakdown / Spot Location</p>
                </div> */}

                {/* Pickup Input */}
                <div style={{ border: '1px solid #21a6e9' }} className="bg-white p-2 rounded-xl mb-2 flex items-center">
                  <input
                  style={{fontSize:'12px'}}
                    className="border-none text-black outline-none w-full sm:text-[12px] md:text-[13px]"
                    onClick={() => setActiveField('pickup')}
                    value={pickupLocation}
                    name="pickup"
                    onChange={handlePickupChange}
                    placeholder="Breakdown / Spot Location"
                  />
                  {pickupLocation && (
                    <button onClick={clearPickup} className="text-gray-400 hover:text-red-500 ml-2">
                      ✖
                    </button>
                  )}
                </div>

                <p className="mb-2 text-[12px] mt-2 opacity-90">Destination Location</p>

                {/* Drop Input */}
                <div style={{ border: '1px solid #21a6e9' }} className="bg-white p-2 rounded-xl mb-3 flex items-center">
                  <input
                  style={{fontSize:'12px'}}
                    placeholder="Where to?"
                    className="border-none text-black outline-none w-full sm:text-[12px] md:text-[16px]"
                    onClick={() => setActiveField('destination')}
                    value={dropLocation}
                    name="drop"
                    onChange={handleDestinationChange}
                  />
                  {dropLocation && (
                    <button onClick={clearDrop} className="text-gray-400 hover:text-red-500 ml-2">
                      ✖
                    </button>
                  )}
                </div>
              </div>

              {/* {!isLoadingPlaces && ( */}
              <div className="mt-[0.3rem] px-2">
                {/* Use My Current Location */}
                <div
                  className="flex items-center gap-3 py-1 cursor-pointer"
                  onClick={() => getCurrentLocationAddress(activeField)}
                >
                  <LocateFixed className="h-5 w-5" />
                  <p className="text-[12px]  font-semibold">Use My Current Location</p>
                </div>

                {/* Select On Map */}
                <div
                  className="flex items-center gap-3 py-1 cursor-pointer"
                  onClick={() => setShowSlideUp(false)}
                >
                  <MapPin className="h-5 w-5" />

                  <p className="text-[12px]  font-semibold">Select On Map</p>
                </div>

                <hr className = 'mt-[0.3rem] mb-[0.3rem]' />

                {/* Location suggestions list */}
                <div className="bg-white mt-2 max-h-[36vh] md:max-h-[16vh] overflow-y-auto">
                  <LocationSearchPanel
                    suggestions={activeField === 'pickup' ? pickupSuggestions : destinationSuggestions}
                    setPickupLocation={setPickupLocation}
                    setDropLocation={setDropLocation}
                    setLatitude={setLatitude}
                    setLongitude={setLongitude}
                    setDropLatitude={setDropLatitude}
                    setDropLongitude={setDropLongitude}
                    activeField={activeField}
                    setShowSlideUp={setShowSlideUp}
                    setIsPickupValid={setIsPickupValid}
                    setIsDropValid={setIsDropValid}
                  />
                </div>
              </div>

            </motion.div>
          )}
          <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[9999] ">
            <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full  gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
              <button
                onClick={() => navigate('/add-new-vehicle-driver')}

                className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"

              >
                <img src={rightArrow} alt="back" className="h-[24px] w-[24px] rotate-180" />
                Back
              </button>


              <button
                disabled={
                  !isPickupValid ||
                  !isDropValid ||
                  pickupLocation?.trim() === '' ||
                  dropLocation?.trim() === '' ||
                  pickupLocation?.toLowerCase().includes('unknown') ||
                  dropLocation?.toLowerCase().includes('unknown')
                }
                onClick={() => {
                  if (
                    isPickupValid &&
                    isDropValid &&
                    pickupLocation?.trim() !== '' &&
                    dropLocation?.trim() !== '' &&
                    !pickupLocation?.toLowerCase().includes('unknown') &&
                    !dropLocation?.toLowerCase().includes('unknown')
                  ) {
                    setCurrentStep('02');
                    localStorage.setItem('currentStep', '02');
                    navigate('/AddVehicles/add-images');
                  }
                }}
                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full ${isPickupValid &&
                    isDropValid &&
                    pickupLocation?.trim() !== '' &&
                    dropLocation?.trim() !== '' &&
                    !pickupLocation?.toLowerCase().includes('unknown') &&
                    !dropLocation?.toLowerCase().includes('unknown')
                    ? 'bg-[#21A6E9] hover:bg-[#1e94d6]'
                    : 'bg-[#a7dbf5] cursor-not-allowed'
                  }`}
              >
                Continue
                <img src={rightArrow} alt="Back" className="h-[24px] w-[24px]" />
              </button>





            </div>
          </div>
        </div>



      </div>
    </div>



  );
};

export default SelectOnMap;
